import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import React from "react";

const Twitter: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30">
            {props.title && <title>{props.title}</title>}
            <path
                fill="#fff"
                d="M15.071 0C6.958 0 .38 6.578.38 14.691c0 8.114 6.578 14.692 14.691 14.692s14.692-6.578 14.692-14.692C29.763 6.578 23.184 0 15.07 0zm7.06 11.074c.01.155.01.315.01.473 0 4.814-3.666 10.359-10.365 10.359-2.066 0-3.982-.6-5.595-1.633.295.033.577.046.879.046a7.307 7.307 0 004.522-1.555 3.643 3.643 0 01-3.404-2.525c.56.082 1.066.082 1.643-.065a3.64 3.64 0 01-2.915-3.575v-.046c.482.272 1.05.44 1.643.463a3.644 3.644 0 01-1.624-3.03c0-.68.178-1.299.496-1.837a10.34 10.34 0 007.51 3.808c-.515-2.476 1.334-4.48 3.557-4.48 1.05 0 1.994.44 2.66 1.148a7.195 7.195 0 002.312-.876 3.625 3.625 0 01-1.6 2.004 7.203 7.203 0 002.098-.568 7.63 7.63 0 01-1.826 1.89z"
            ></path>
        </svg>
    );
};

export default React.memo(Twitter);
